import _ from 'lodash'

export const makeMetadata = (resourceFields) => {
  return {
    title: _.get(resourceFields, 'pageTitle') || _.get(resourceFields, 'contentTitle'),
    description: _.get(resourceFields, 'pageMetaDescription'),
    keywords: _.get(resourceFields, 'pageMetaKeywords')
  }
}
